import { createContext, useContext } from 'react';

export const InterfacePortalContext = createContext<Element | null>(null);

export function useInterfacePortalContainer() {
  return useContext(InterfacePortalContext);
}
